<template>
  <div class="col-md-8 col-sm-10 mx-auto">
    <div v-if="formState === 'showForm'">
      <h2>Submit a key</h2>
      <p v-if="formErrors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="(error, index) in formErrors" v-bind:key="index" class="text-danger">{{ error }}</li>
        </ul>
      </p>
      <form>
        <div class="form-group input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><font-awesome-icon icon="gamepad" fixed-width /></span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Game name"
            v-model="form.name"
          >
        </div>
        <div class="form-group input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><font-awesome-icon icon="key" fixed-width /></span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Game key"
            v-model="form.key"
          >
        </div>
        <div class="form-group input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><font-awesome-icon icon="edit" fixed-width /></span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Notes"
            v-model="form.notes"
          >
        </div>
        <div v-for="(row, index) in form.rows" v-bind:key="index">
          <hr/>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="gamepad" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control input-sm"
              :placeholder="'DLC '+ (index+1) +' name'"
              v-model="row.name"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="key" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control input-sm"
              :placeholder="'DLC '+ (index+1) +' key'"
              v-model="row.key"
            >
          </div>
          <div class="form-group input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><font-awesome-icon icon="edit" fixed-width /></span>
            </div>
            <input
              type="text"
              class="form-control input-sm"
              :placeholder="'DLC '+ (index+1) +' notes'"
              v-model="row.notes"
            >
          </div>
          <button type="button" v-on:click="removeRow(index);" class="btn btn-danger btn-sm">Remove</button>
        </div>
        <hr/>
        <div class="row">
          <button type="button" v-on:click='addRow()' class='btn btn-secondary'>Add DLC</button>
          <div style="width:15px;height:auto;display:inline-block;" />
          <button type="submit"  v-on:click='submitKey()' class='btn btn-success' v-if="!loading">Submit Key</button>
          <div v-if="loading" class="spinner-border text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </form>
    </div>
    <div v-if="formState === 'submitError'">
      <h2>Error submitting key</h2>
      <p>{{ submitError }}</p>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'submit',
  props: ['user'],
  data() {
    return {
      formState: 'showForm',
      loading: false,
      form: {
        name: '',
        key: '',
        notes: '',
        rows: []
      },
      formErrors: [],
      submitError: {},
      submittedKey: {}
    }
  },
  methods: {
    async submitKey() {
      this.formErrors = [];

      // Check main key fields
      if (!this.form.name.length) {
        this.formErrors.push('Name is required');
      }
      if (!this.form.key.length) {
        this.formErrors.push('Key is required');
      }

      // Check DLC fields
      for (var i = 0; i < this.form.rows.length; i++) {
        if (!this.form.rows[i].name.length) {
          this.formErrors.push(`Name for DLC ${i+1} is required`);
        }
        if (!this.form.rows[i].key.length) {
          this.formErrors.push(`Key for DLC ${i+1} is required`);
        }
      }

      if (!this.formErrors.length) { // If there were no errors
        this.loading = true

        // Build input object for mutation
        var input = {
          name: this.form.name,
          key: this.form.key,
          submitter: this.user.username
        }
        if (this.form.notes.length) {
          input.notes = this.form.notes
        }
        if (this.form.rows.length) {
          input.dlcs = this.form.rows
        }

        // Do api call
        this.$apollo.mutate({
          mutation: gql`mutation submitKey ($name: String!, $key: String!, $notes: String, $submitter: String!, $dlcs: [DlcInput!]) {
            submitKey(name: $name, key: $key, notes: $notes, submitter: $submitter dlcs: $dlcs) {
              KeyId
            }
          }`,
          variables: input
        }).then((data) => {
          // Change form to submitted confirmation
          this.$router.push('/match/'+data.data.submitKey.KeyId)
        }).catch((error) => {
          // Change form to submitted confirmation
          this.formState = 'submitError'
          this.submitError = error
          this.loading = false
          window.scrollTo(0,0)
        })
      } else {
        // If there were errors scroll up to the list of errors
        window.scrollTo(0,0)
      }
    },
    async clearForm() {
      // Clear form for next entry
      this.form = {
        name: '',
        key: '',
        notes: '',
        rows: []
      }
      this.formErrors = []
      // Change state so form shows
      this.formState = 'showForm'
    },
    async addRow() {
      this.form.rows.push({name: '', key: '', notes: ''})
    },
    async removeRow(index) {
      this.form.rows.splice(index, 1)
    }
  }
}
</script>